import React from "react";

import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import ReportBanner from "../Pages/Report/Report";
import Reportcenter from "../Pages/Report/Reportcenter";

import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Reporttheme() {
  return (
    <>
      <Header />
      <ReportBanner />
      <Reportcenter />
      <Latestupdate />
      <Footer />
    </>
  );
}
